if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getSelectedVolume(formData) {
        /*
         * ALIMMA SCENTS
         * Detect selected Volume across different Dawn versions.
         */

        const normalise = (value) => {
          return value ? String(value).trim().toUpperCase() : null;
        };

        /*
         * 1. Check values contained directly in the submitted product form.
         */
        for (const [name, value] of formData.entries()) {
          if (
            name === 'Volume' ||
            name === 'options[Volume]' ||
            /^Volume-\d+$/.test(name)
          ) {
            return normalise(value);
          }
        }

        /*
         * 2. Check inputs linked to this form by the "form" attribute.
         */
        if (this.form.id) {
          const checkedVolume =
            document.querySelector(
              `input[form="${this.form.id}"][name="Volume"]:checked`
            ) ||
            document.querySelector(
              `input[form="${this.form.id}"][name^="Volume-"]:checked`
            ) ||
            document.querySelector(
              `input[form="${this.form.id}"][name="options[Volume]"]:checked`
            );

          if (checkedVolume) {
            return normalise(checkedVolume.value);
          }

          const volumeSelect =
            document.querySelector(
              `select[form="${this.form.id}"][name="Volume"]`
            ) ||
            document.querySelector(
              `select[form="${this.form.id}"][name="options[Volume]"]`
            );

          if (volumeSelect) {
            return normalise(volumeSelect.value);
          }
        }

        /*
         * 3. Check within the current product area.
         */
        const productArea =
          this.closest('.product') ||
          this.closest('.product__info-container') ||
          this.closest('section') ||
          document;

        const checkedVolume =
          productArea.querySelector('input[name="Volume"]:checked') ||
          productArea.querySelector('input[name^="Volume-"]:checked') ||
          productArea.querySelector('input[name="options[Volume]"]:checked');

        if (checkedVolume) {
          return normalise(checkedVolume.value);
        }

        const volumeSelect =
          productArea.querySelector('select[name="Volume"]') ||
          productArea.querySelector('select[name="options[Volume]"]');

        if (volumeSelect) {
          return normalise(volumeSelect.value);
        }

        /*
         * 4. Final fallback:
         * Look for a checked radio/button containing a refill size.
         */
        const allCheckedInputs = productArea.querySelectorAll(
          'input[type="radio"]:checked'
        );

        for (const input of allCheckedInputs) {
          const value = normalise(input.value);

          if (
            value === '5 ML' ||
            value === '10 ML' ||
            value === '15 ML' ||
            value === '20 ML' ||
            value === '25 ML' ||
            value === '50 ML'
          ) {
            return value;
          }
        }

        return null;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        /*
         * =========================================================
         * ALIMMA SCENTS
         * Automatic Refillable Perfume Bottle Mapping
         * =========================================================
         */

        const refillBottleVariants = {
          '5 ML': 54620302803219,
          '10 ML': 54620302835987,
          '15 ML': 54620302868755,
          '20 ML': 54620302901523,
          '25 ML': 54620302934291,
          '50 ML': 54696307884307
        };

        const refillEnabled =
          this.dataset.alimmaRefillEnabled === 'true';

        const selectedVolume = refillEnabled
          ? this.getSelectedVolume(formData)
          : null;

        const bottleVariantId =
          selectedVolume
            ? refillBottleVariants[selectedVolume]
            : null;

        /*
         * =========================================================
         * DECANT / REFILL SIZE
         * Add perfume + matching refillable bottle together.
         * =========================================================
         */

        if (refillEnabled && bottleVariantId) {
          const perfumeProperties = {};

          /*
           * Preserve any existing line-item properties.
           */
          for (const [name, value] of formData.entries()) {
            const propertyMatch = name.match(/^properties\[(.+)\]$/);

            if (propertyMatch) {
              perfumeProperties[propertyMatch[1]] = value;
            }
          }

          /*
           * Internal properties beginning with "_"
           * link the perfume with its refillable bottle.
           */
          perfumeProperties._alimma_refill_size = selectedVolume;

          const items = [
            {
              id: Number(variantId),
              quantity: quantity,
              properties: perfumeProperties
            },
            {
              id: Number(bottleVariantId),
              quantity: quantity,
              properties: {
                _alimma_parent_variant: String(variantId),
                _alimma_refill_size: selectedVolume
              }
            }
          ];

          /*
           * Preserve selling plan if ever used.
           */
          const sellingPlan = formData.get('selling_plan');

          if (sellingPlan) {
            items[0].selling_plan = Number(sellingPlan);
          }

          const requestBody = {
            items: items
          };

          if (this.cart) {
            requestBody.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id);

            requestBody.sections_url = window.location.pathname;

            this.cart.setActiveElement(document.activeElement);
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(requestBody);

        } else {
          /*
           * =========================================================
           * NORMAL SHOPIFY BEHAVIOUR
           * Full bottles and all non-perfume products.
           * =========================================================
           */

          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;
        }

        /*
         * =========================================================
         * ORIGINAL DAWN FETCH / CART LOGIC
         * =========================================================
         */

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButton
                .querySelector('span')
                .classList.add('hidden');

              soldOutMessage.classList.remove('hidden');

              this.error = true;
              return;

            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response
              });
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);

            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector(
              '.loading-overlay__spinner'
            ).classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}